export default __webpack_public_path__ + "2faf4dcd4330050d93ca55bdb423ff48.png";